var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNuvem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 31,
    viewBox: "0 0 43 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8809 4.43319C27.6078 2.49443 24.6663 1.35791 21.3904 1.35791C14.4376 1.35791 8.82191 6.63937 8.62134 13.1242C4.40955 13.4585 1 17.0017 1 21.3472C1 25.8933 4.67696 29.5702 9.22302 29.5702H28.2095H33.3573C37.9702 29.5702 41.714 25.8264 41.714 21.2135C41.714 19.8764 41.3797 18.6731 40.8449 17.5365",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.97 9.58057L34.761 12.9901C34.6273 13.1238 34.4268 13.1907 34.2262 13.1907H34.1593C34.0256 13.1907 33.8251 13.1238 33.7582 12.9901L32.02 11.0514",
    stroke: "#F59B1B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9618 18.071C38.6171 18.071 41.5803 15.1078 41.5803 11.4525C41.5803 7.7972 38.6171 4.83398 34.9618 4.83398C31.3065 4.83398 28.3433 7.7972 28.3433 11.4525C28.3433 15.1078 31.3065 18.071 34.9618 18.071Z",
    stroke: "#F59B1B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNuvem);
export default __webpack_public_path__ + "static/media/icon_nuvem.77de8044c2932043e3c01592f0c36617.svg";
export { ForwardRef as ReactComponent };